import {
  LabelText,
  RadioButton,
  SelectField,
} from "@fanduel/formation-react-components";
import { usePlayerStatsContext } from "@/utils/hooks/useHeadToHeadPlayerStatsContext";
import { PositionFilter } from "./util";
import styles from "./positionSelector.module.scss";

enum PositionLabel {
  QB = "QB",
  RB = "RB",
  WR = "WR",
  TE = "TE",
  FLEX = "RB/WR/TE (Flex)",
  K = "K",
  D = "Defense",
}

const SELECTION_OPTIONS = [
  { label: PositionLabel.QB, value: PositionFilter.QUARTERBACK },
  { label: PositionLabel.RB, value: PositionFilter.RUNNING_BACK },
  { label: PositionLabel.WR, value: PositionFilter.RECEIVER },
  { label: PositionLabel.TE, value: PositionFilter.TIGHT_END },
  { label: PositionLabel.FLEX, value: PositionFilter.FLEX },
  { label: PositionLabel.K, value: PositionFilter.KICKER },
  { label: PositionLabel.D, value: PositionFilter.DEFENSE },
];

type Props = {
  isMobile: boolean;
};

export default function PositionSelector({ isMobile }: Props) {
  const { setPosition, isSelected } = usePlayerStatsContext();
  const buildOnChange = (id: PositionFilter) => () => setPosition(id);

  return isMobile ? (
    <SelectField
      id="position-selection"
      label="Type"
      css={{ marginBottom: 16 }}
      onValueChange={(value) => setPosition(value as PositionFilter)}
      options={SELECTION_OPTIONS}
    />
  ) : (
    <>
      <LabelText
        as="label"
        id="position-selection-label"
        className={styles.radioLabel}
      >
        Type
      </LabelText>
      <fieldset
        className={styles.radioBtns}
        aria-labelledby="position-selection-label"
      >
        <RadioButton
          id={PositionFilter.QUARTERBACK}
          onChange={buildOnChange(PositionFilter.QUARTERBACK)}
          selected={isSelected(PositionFilter.QUARTERBACK)}
          label={PositionLabel.QB}
        />
        <RadioButton
          id={PositionFilter.RUNNING_BACK}
          onChange={buildOnChange(PositionFilter.RUNNING_BACK)}
          selected={isSelected(PositionFilter.RUNNING_BACK)}
          label={PositionLabel.RB}
        />
        <RadioButton
          id={PositionFilter.RECEIVER}
          onChange={buildOnChange(PositionFilter.RECEIVER)}
          selected={isSelected(PositionFilter.RECEIVER)}
          label={PositionLabel.WR}
        />
        <RadioButton
          id={PositionFilter.TIGHT_END}
          onChange={buildOnChange(PositionFilter.TIGHT_END)}
          selected={isSelected(PositionFilter.TIGHT_END)}
          label={PositionLabel.TE}
        />
        <RadioButton
          id={PositionFilter.FLEX}
          onChange={buildOnChange(PositionFilter.FLEX)}
          selected={isSelected(PositionFilter.FLEX)}
          label={PositionLabel.FLEX}
        />
        <RadioButton
          id={PositionFilter.KICKER}
          onChange={buildOnChange(PositionFilter.KICKER)}
          selected={isSelected(PositionFilter.KICKER)}
          label={PositionLabel.K}
        />
        <RadioButton
          id={PositionFilter.DEFENSE}
          onChange={buildOnChange(PositionFilter.DEFENSE)}
          selected={isSelected(PositionFilter.DEFENSE)}
          label={PositionLabel.D}
        />
      </fieldset>
    </>
  );
}
